import { useRef, useState } from "react";
import api from "../api";
import { useI18n } from "../i18n";
import { Button } from "@/components/ui/button";
import { Upload, X, Loader2 } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function fullUrl(u) {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${BACKEND}${u}`;
}

export default function ImageUpload({ label, value, onChange, testid }) {
  const { t } = useI18n();
  const ref = useRef();
  const [loading, setLoading] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
    } finally { setLoading(false); }
  };

  return (
    <div>
      <div className="mb-1.5 text-xs text-slate-500">{label}</div>
      {value ? (
        <div className="relative h-28 w-full overflow-hidden rounded-lg border border-slate-200">
          <img src={fullUrl(value)} alt="" className="h-full w-full object-cover" />
          <button type="button" data-testid={`${testid}-remove`} onClick={() => onChange("")} className="absolute right-1 top-1 rounded-full bg-slate-900/80 p-1 text-white"><X size={14} /></button>
        </div>
      ) : (
        <>
          <input ref={ref} type="file" accept="image/*" className="hidden" data-testid={testid} onChange={pick} />
          <Button type="button" variant="outline" className="h-28 w-full flex-col gap-2 border-dashed" onClick={() => ref.current?.click()} disabled={loading}>
            {loading ? <Loader2 className="animate-spin" size={20} /> : <Upload size={20} />}
            <span className="text-xs">{loading ? t("uploading") : t("upload")}</span>
          </Button>
        </>
      )}
    </div>
  );
}
